export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3256850084f7d88e538ed507935802bc.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
          Secure Your Digital<br />
          Freedom with<br />
          Advanced VPN
        </h1>
        <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto leading-relaxed">
          Experience enterprise-grade security and privacy protection with IGANA's cutting-edge VPN technology and innovative applications
        </p>
        <button
          onClick={scrollToContact}
          className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:from-teal-600 hover:to-teal-700 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
        >
          Start Free Trial
          <i className="ri-arrow-right-line text-xl"></i>
        </button>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}
